import { type InputBaseComponentProps } from '@mui/material/InputBase';
import { forwardRef, useImperativeHandle, useState } from 'react';

// NOTE: This implementation comes from the following discussion in https://github.com/mui/material-ui/issues/16037
export const Input = forwardRef<any, InputBaseComponentProps>(
  function Input(props, ref) {
    const { component: Component, ...otherProps } = props;
    const [mountNode, setMountNode] = useState<any | null>(null);

    useImperativeHandle(
      ref,
      () => ({
        focus: /* istanbul ignore next */ () => mountNode.focus()
      }),
      [mountNode]
    );

    return <Component onReady={setMountNode} {...otherProps} />;
  }
);
